module.exports = __webpack_public_path__ + "media/images/marketing/video_thumbnail3-b6964ead0c0637322722345b407c45fb77af52292847b4a9d18001cc8960a2bf.png";